export const TRACKER_PAGE_ELEMENTS = {
  assessment: 'CLICK_ASSESSMENT_PAGE',
  'perangkat-ajar': 'CLICK_TOOLKIT_PAGE',
  'pelatihan-mandiri': 'CLICK_MICRO_LEARNING',
  'bukti-karya': 'CLICK_BUKTI_KARYA',
  komunitas: 'CLICK_LEARNING_COMMUNITY',
  'video-inspirasi': 'CLICK_VIDEO_INSPIRATION',
}
